


import TiwiMixin from '../mixins/TiwiMixin'

import ModalPopup from './ModalPopup';
import ActivityIndicator from './ActivityIndicator'

export default {
  mixins: [TiwiMixin],
  props: {
   
  },
  components: { ModalPopup, ActivityIndicator },
  data() {
    return {

      form_config: null,
      form_data: {
        first_name: '',
        last_name: '',
        email: '',
        topic: '',
        message: '',
        file: null,
      },
      form_validation:{
        result: null,
        errors: {}
      },


      show_modal: false,
      modal_message: '',
    }
  },
  mounted: function () {
    this.getConfig();

   

  },
  computed: {
   
  },
  methods: {
    getConfig: function () {

      var self = this;
      self.setLoading(true);

      this.api.get('support/getFormConfig')
        .then((response) => {
          if( response.data.config)
            this.form_config  = response.data.config;

        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
        .finally(() => self.setLoading(false))
    },
    handleFileClick: function(e){
      console.log('CLICK');
        this.$refs.file_button.click();
    },
    handleFileChange: function( event ){


      this.form_data.file = event.target.files[0];
    },
    submitForm: function(){
      var self = this;
      

      const form = new FormData();


      var recipient = this.form_data.topic?.recipient ? this.form_data.topic.recipient : this.form_config.default_recipient;

      
      form.append('first_name', this.form_data.first_name);
      form.append('last_name', this.form_data.last_name);
      form.append('email', this.form_data.email);
      form.append('topic', this.form_data.topic ? this.form_data.topic.name : '');
      form.append('message', this.form_data.message);
      form.append('recipient', recipient);
      
      form.append('file', this.form_data.file );

      this.setLoading(true);

      this.api.post('support/submitForm', form).then((response) => {

        if(  !response.data.success ){
          self.toast.error( response.data.message );
        }
        else{
          self.modal_message = response.data.message;
          self.show_modal = true;
        }

        if( response.data.validation ){
          self.form_validation = response.data.validation;
        }
        
        // self.resetForm();

      })
      .catch( (err)  => {  self.handleError(err);} )
      .finally( () => { self.setLoading(false);} );
      
    },
    resetForm: function(){
      this.form_data = {
        first_name: '',
        last_name: '',
        email: '',
        topic: null,
        message: '',
        file: null,
      }
    },
    onModalClose: function(){
      this.show_modal = false;
      this.resetForm();
    }




  },
  watch: {
   
    user: function( newVal ){

      if( newVal ){
        this.form_data.first_name = newVal.first_name;
        this.form_data.last_name = newVal.last_name;
        this.form_data.email = newVal.email;
      }

    }
  },
  computed: {
    formDisabled: function(){
      return this.loading;
    }
  }
}
